import { HiPencilSquare } from "react-icons/hi2";

export const EditProfileIcon = ({ width, height, color, ...props }) => (
  <HiPencilSquare
    size={width || height || 12}
    color={color || "currentColor"}
    {...props}
  />
);
